import styled from 'styled-components';
import { padding, PaddingProps } from 'styled-system';

export const SkeletonWrapper = styled.td<PaddingProps>`
  flex: 1;
  ${padding};
`;
SkeletonWrapper.defaultProps = {
  paddingY: 4,
};
